export type LastSyncStatus = 'completed' | 'failed' | undefined;

export function renderSyncIcon(lastSyncStatus: LastSyncStatus): string {
  if (lastSyncStatus === 'completed') return ' ✓';
  if (lastSyncStatus === 'failed') return ' ✗';
  return '';
}
